import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"

@Injectable({
    providedIn: 'root'
})
export class ChecklistTemplatesApiService {

    constructor(private http: HttpClient) { }

    public create(data:any) {
        return this.http.post(API_HOST + 'checklist-templates', data)
    }

    public update(id, data:any) {
        return this.http.put(API_HOST + `checklist-templates/${id}`, data)
    }

    public delete(id:string) {
        return this.http.delete(API_HOST + `checklist-templates/${id}`)
    }

    public get(params) {
        return this.http.get(API_HOST + `checklist-templates?` + new URLSearchParams(params).toString())
    }
    
    // public getById(id:string) {
    //     return this.http.get(API_HOST + `checklists/${id}`)
    // }

}